export default "__VITE_ASSET__CChsZJ8___"